import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

class Maps extends Component {
  render() {
    return (
      <Map
        style={{ height: "100%", width: "100%" }}
        google={this.props.google}
        zoom={80}
      >
        <Marker onClick={this.onMarkerClick} name={"Current location"} />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyBEcae1-TyOuL1O7XOoRk-xqBuh6UhPQ7A",
})(Maps);
